import React from 'react';
import block from 'bem-cn';
import PT from 'prop-types';
import { useSelector } from 'react-redux';

import Input from 'components/Input';
import Button from 'components/Button';

import './BithidePaymentMain.scss';

const b = block('bithide-payment-main');

const BithidePaymentMain = ({
  tndAmount,
  usdtAmount,
  onUsdtAmountChange,
  onDepositInit,
}) => {
  const { locale } = useSelector(state => state.locale);
  const { rate } = useSelector(state => state.payment);

  return (
    <div className={b()}>
      <div className={b('fields')}>
        <label className={b('field')}>
          <p className={b('label')}>
            {locale.enterThePaymentAmount}
          </p>
          <div className={b('input')}>
            <Input
              name="usdtAmount"
              value={usdtAmount}
              callBack={e => onUsdtAmountChange(e.target.value)}
              placeholder='0.00'
              type="number"
              measure="USDT"
            />
          </div>
        </label>

        <label className={b('field')}>
          <p className={b('label')}>
            {locale.balanceAmountForPurchase}
          </p>
          <div className={b('input')}>
            <Input
              name="tndAmount"
              value={tndAmount}
              callBack={() => {}}
              placeholder='0.00'
              type="number"
              disabled
              measure="TND"
            />
          </div>
        </label>
      </div>

      <p className={b('rate')}>
        {`${locale.rate} 1 USDT = ${rate} TND`}
      </p>

      <div className={b('button')}>
        <Button onClick={onDepositInit} text={locale.topUp2} />
      </div>
    </div>
  )
};

BithidePaymentMain.propTypes = {
  // tndAmount: PT.oneOf([PT.string, PT.number, PT.any]),
  // usdtAmount: PT.oneOf([PT.string, PT.number, PT.any]),
  // onUsdtAmountChange: PT.func,
  // onDepositInit: PT.func,
};

export default BithidePaymentMain;
